import script from "./BaseSlideCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSlideCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__